import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_COMPANY_FEATURE_KEY,
	CorrespondenceCompanyState,
	CorrespondenceCompanyPartialState,
	correspondenceCompanyAdapter
} from './company.reducer';

// Lookup the 'CorrespondenceCompany' feature state managed by NgRx
export const getCorrespondenceCompanyState = createFeatureSelector<
	CorrespondenceCompanyPartialState,
	CorrespondenceCompanyState
>(CORRESPONDENCE_COMPANY_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceCompanyAdapter.getSelectors();

export const getCorrespondenceCompanyLoaded = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => state.loaded
);

export const getCorrespondenceCompanyError = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => state.error
);

export const loadingCorrespondenceCompany = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => state.loaded
);

export const getAllCorrespondenceCompany = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => selectAll(state)
);

export const getCorrespondenceCompanyEntities = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceCompanyState,
	(state: CorrespondenceCompanyState) => state.selectedCorrespondenceCompanyId
);

export const getSelected = createSelector(
	getCorrespondenceCompanyEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
